export default __webpack_public_path__ + "static/media/Ontraccr-Logo-W-1400x400.0cdb344e.png";